import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  apps: null,
  originationCountries: null,
  countries: null,
  callingCorridors: null
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/competitor/index.js